import { NavigationButton } from "@components/common/NavigationLink";
import { CarCrash, DirectionsCar, LocalShipping, Repeat } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import { Box, Button, Modal, Stack, Typography } from "@mui/material";
import { RoutePaths } from "@utils/constants/routes";
import React from "react";
import { useTranslation } from "react-i18next";

import { useUserContext } from "@/contexts/UserContext/index.context";
import { UserRole } from "@/types/models/user.type";

const style = {
  position: "absolute" as const,
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "max-content",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 2,
};

function AddNewDeals() {
  const { t } = useTranslation();
  const { userState } = useUserContext();

  const isAdmin = userState?.["custom:role"] === UserRole.ADMIN;
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Button
        variant="contained"
        onClick={handleOpen}
        color="primary"
        size="small"
        startIcon={<AddIcon />}
      >
        {t("layouts.header.new-delivery")}
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            marginBottom={2}
            sx={{
              fontSize: "1.5rem",
              fontWeight: 600,
              textAlign: "center",
              color: "primary.main",
              "&::first-letter": {
                textTransform: "capitalize",
              },
              textShadow: "0 1px 2px rgba(0,0,0,0.1)",
              textTransform: "uppercase",
            }}
          >
            {t("layouts.sub-headers.deliveries.select-delivery-type")}
          </Typography>
          <Box
            sx={{
              width: "100%",
              height: "2px",
              background: (theme) => theme.palette.divider,
              marginBottom: 3,
              boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
            }}
          />
          <Stack direction="row" gap={2} flexWrap="wrap">
            <NavigationButton
              to={`${isAdmin ? RoutePaths.adminNewDelivery : RoutePaths.clientNewDelivery}/standard`}
              includes="/standard"
              sx={{
                width: 200,
                textTransform: "uppercase",
              }}
              variant="contained"
              color="Standard"
              icon={<DirectionsCar sx={{ fontSize: "1.25rem" }} />}
            >
              {t("layouts.sub-headers.deliveries.standard")}
            </NavigationButton>
            <NavigationButton
              to={`${isAdmin ? RoutePaths.adminNewDelivery : RoutePaths.clientNewDelivery}/to-return`}
              includes="/to-return"
              variant="contained"
              sx={{
                width: 200,
                textTransform: "uppercase",
              }}
              color="toReturn"
              icon={<CarCrash sx={{ fontSize: "1.25rem" }} />}
            >
              {t("layouts.sub-headers.deliveries.to-return")}
            </NavigationButton>

            <NavigationButton
              to={`${isAdmin ? RoutePaths.adminNewDelivery : RoutePaths.clientNewDelivery}/two-way-delivery`}
              includes="/two-way-delivery"
              sx={{
                width: 300,
                textTransform: "uppercase",
              }}
              variant="contained"
              color="TWO_WAY_DELIVERY"
              icon={<Repeat sx={{ fontSize: "1.25rem" }} />}
            >
              {t("layouts.sub-headers.deliveries.two-way-delivery")}
            </NavigationButton>

            <NavigationButton
              to={`${isAdmin ? RoutePaths.adminNewDelivery : RoutePaths.clientNewDelivery}/okm`}
              includes="/two-way-delivery"
              sx={{
                width: 200,
                textTransform: "uppercase",
              }}
              variant="contained"
              color="OKM"
              icon={<LocalShipping sx={{ fontSize: "1.25rem" }} />}
            >
              {t("layouts.sub-headers.deliveries.okm")}
            </NavigationButton>
          </Stack>
        </Box>
      </Modal>
    </>
  );
}

export default AddNewDeals;
